import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { selectUserInfo } from "../../redux/User";
import Api from "../../Api";

const Header = ({ toggleSidebar }: { toggleSidebar?: () => void }) => {
  const navigate = useNavigate();
  const api = Api();

  const { userInfo } = useSelector((store: any) => ({
    userInfo: selectUserInfo(store),
  }));

  const onPressLogout = () => {
    api.user.logout();
    navigate("/login");
  };

  return (
    <>
      <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow-sm px-4">
        {/* Topbar Search */}
        <form className="d-none d-md-inline-block form-inline mr-auto my-2 my-md-0 mw-100 navbar-search" style={{ width: '350px' }}>
          <div className="input-group align-items-center" style={{ backgroundColor: '#f4f6f9', borderRadius: '30px', padding: '4px 16px' }}>
            <i className="fas fa-search fa-sm text-gray-400 mr-2"></i>
            <input type="text" className="form-control bg-transparent border-0 small shadow-none" placeholder="Search data..." aria-label="Search" style={{ fontSize: '0.9rem' }} />
          </div>
        </form>

        <button
          className="btn btn-link d-md-none rounded-circle mr-3"
          onClick={toggleSidebar}
        >
          <i className="fa fa-bars"></i>
        </button>

        <ul className="navbar-nav ml-auto align-items-center">
          
          {/* Nav Item - Alerts */}
          <li className="nav-item dropdown no-arrow mx-1 d-none d-sm-block">
            <a className="nav-link dropdown-toggle text-gray-500" href="#" id="alertsDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i className="far fa-bell fa-lg"></i>
            </a>
          </li>

          {/* Nav Item - Help */}
          <li className="nav-item dropdown no-arrow mx-1 d-none d-sm-block">
            <a className="nav-link dropdown-toggle text-gray-500" href="#" id="helpDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i className="far fa-question-circle fa-lg"></i>
            </a>
          </li>

          <div className="topbar-divider d-none d-sm-block mx-3"></div>

          {/* Nav Item - User Information */}
          <li className="nav-item dropdown no-arrow">
            <a
              className="nav-link dropdown-toggle"
              href="#"
              id="userDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <div className="d-flex align-items-center">
                <div className="img-profile rounded-circle d-flex align-items-center justify-content-center bg-primary text-white mr-2" style={{width: '36px', height: '36px'}}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                </div>
                <div className="d-none d-lg-flex flex-column align-items-start justify-content-center">
                  <span className="text-dark font-weight-bold text-capitalize" style={{ fontSize: '0.9rem', lineHeight: '1.2' }}>
                    {userInfo.firstName ? `${userInfo.firstName} ${userInfo.lastName || ''}`.trim() : 'Admin User'}
                  </span>
                  <span className="text-uppercase text-muted" style={{ fontSize: '0.65rem', fontWeight: '600', letterSpacing: '0.5px' }}>
                    Admin
                  </span>
                </div>
              </div>
            </a>

            <div
              className="dropdown-menu dropdown-menu-right shadow animated--grow-in"
              aria-labelledby="userDropdown"
            >
              <a
                className="dropdown-item"
                href="#"
                data-toggle="modal"
                data-target="#logoutModal"
              >
                <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                Logout
              </a>
            </div>
          </li>
        </ul>
      </nav>

      <div
        className="modal fade"
        id="logoutModal"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Ready to Leave?
              </h5>
              <button
                className="close"
                type="button"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              Select "Logout" below if you are ready to end your current
              session.
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-secondary"
                type="button"
                data-dismiss="modal"
              >
                Cancel
              </button>
              <button
                className="btn btn-primary"
                type="button"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => onPressLogout()}
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
